/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MediaStrictHttpResponse } from '../../media-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientModel } from '../../models/client-model';

export interface ClientIdGet$Json$Params {
  id: string;
}

export function clientIdGet$Json(http: HttpClient, rootUrl: string, params: ClientIdGet$Json$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<ClientModel>> {
  const rb = new RequestBuilder(rootUrl, clientIdGet$Json.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MediaStrictHttpResponse<ClientModel>;
    })
  );
}

clientIdGet$Json.PATH = '/Client/{id}';
